module.exports = __webpack_public_path__ + "img/lab_ochem.531d05d9.png";